export const getDiagnosticMetrics = (auditData = {}) => {
  const sections = auditData.sections || {};
  const ratings = Object.values(sections).flatMap(section => section?.ratings || []);
  const answeredRatings = ratings.filter(rating => Number(rating) > 0).length;
  const totalRatings = ratings.length || 20;
  const notesCaptured = Object.values(sections).filter(section => (section?.notes || '').trim().length > 0).length;
  const toolsMapped = Object.values(auditData.tech_stack || {}).reduce((sum, stack) => sum + ((stack?.tools || []).length), 0);
  const integrationScores = Object.values(auditData.tech_stack || {}).filter(stack => Number(stack?.integration_rating) > 0).length;
  const roiItems = (auditData.roi_items || []).length;
  const manualWorkCost = (auditData.roi_items || []).reduce((sum, item) => sum + (Number(item?.annual) || 0), 0);
  const readinessChecked = Object.values(auditData.readiness_inputs || {}).filter(Boolean).length;
  const riskInputs = auditData.risk_inputs || {};
  const riskFlags = ['sensitive_data', 'customer_messages', 'money_or_commitments'].filter(key => Boolean(riskInputs[key])).length;
  const hasApprovalOwner = Boolean((riskInputs.approval_owner || '').trim());

  const weightedSignals = answeredRatings + notesCaptured * 2 + toolsMapped + integrationScores * 2 + roiItems * 4 + readinessChecked * 2 + (hasApprovalOwner ? 2 : 0);
  const completionPercent = Math.min(100, Math.round((weightedSignals / 55) * 100));

  let readinessLabel = 'Building context';
  if (roiItems > 0 && readinessChecked >= 2 && hasApprovalOwner) readinessLabel = 'Ready for first-pilot guidance';
  else if (answeredRatings >= 10 && toolsMapped >= 3) readinessLabel = 'Enough signals for early diagnosis';

  return {
    answeredRatings,
    totalRatings,
    notesCaptured,
    toolsMapped,
    integrationScores,
    roiItems,
    manualWorkCost,
    readinessChecked,
    riskFlags,
    hasApprovalOwner,
    completionPercent,
    readinessLabel,
    signalsCaptured: weightedSignals
  };
};
